// extracted by mini-css-extract-plugin
export default {"input":"TextArea_input__v++Td","disabled":"TextArea_disabled__NeM69"};